<template>
  <v-container fill-height
               fluid
               pa-0
               style="background-image: radial-gradient(farthest-corner at 50% 50%, #004678 20%, #042345 100%);"
  >
    <v-row class="fill-height" no-gutters>
      <top-bar>
        <template v-slot:logos>
          <v-row class="fill-height pt-6 pl-6" no-gutters>
            <v-col class="flex-shrink-1 pr-4" cols="auto">
              <v-img max-width="115" src="@/assets/logos/fitt_logo.svg"></v-img>
            </v-col>
<!--            <v-col class="flex-shrink-1 " cols="auto">-->
<!--              <v-img contain max-width="150" src="@/assets/logos/psychai_logo.png"></v-img>-->
<!--            </v-col>-->
          </v-row>
        </template>
        <template v-slot:title>
          The Leader of the Future
        </template>
        <template v-slot:info>
          <v-row class="pt-10 pr-12 white--text" justify="end" no-gutters>
            <div class="title font-weight-light" v-if="timeText">Time:</div>
            <div class="title font-weight-bold mr-12 ml-2" v-if="timeText">{{ timeText }}</div>
            <v-btn dark icon x-large absolute top right style="top: 30px;"
                   @click="$router.replace(`/${$route.params.app}/menu`)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </template>
      </top-bar>
      <v-col cols="12" v-if="data">
        <v-container>
          <v-row no-gutters justify="center">
            <v-col cols="12" style="max-width: 914px;">
              <div class="display-1 white--text font-weight-light">
                <v-row no-gutters justify="space-between" align="center">
                  <v-col cols="auto">
                    {{ data.title }}
                  </v-col>
                  <v-col cols="auto">
                    <v-btn outlined color="white" @click="reset()">
                      Reset
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
              <div class="white--text mt-4" style="font-size: 20px;">
                {{ data.description }}
              </div>
            </v-col>
            <v-col cols="12">
              <v-row justify="center">
                <v-col cols="auto"
                       style="min-width: 174px;"
                       v-for="(group, index) in data.item_groups"
                       :key="index"
                >
                  <div class="white--text font-weight-light text-center mb-1">
                    {{ group.title }}
                  </div>
                  <draggable group="answers"
                             style="min-height: 443px; border: 2px dotted white; border-radius: 5px; min-width: 162px;"
                             v-model="group.items"
                             @start="onStart(group.items)"
                  >
                    <div v-for="(item, index) in group.items"
                         :key="index"
                         class="ma-1"
                    >
                      <v-card class="black--text pa-2 handle"
                              style="font-size: 14px; cursor: pointer; user-select: none;"
                              :width="150"
                              :height="58"
                      >
                        <v-row no-gutters justify="center" align="center" class="fill-height">
                          <v-col cols="auto">
                            <div class="text-center">{{ item }}</div>
                          </v-col>
                        </v-row>
                      </v-card>
                    </div>
                  </draggable>
                </v-col>
                <v-col cols="auto" style="min-width: 67px;">
                  <v-img src="@/assets/images/large_arrow_right.svg" class="mt-6"></v-img>
                </v-col>
                <v-col cols="auto">
                  <div v-for="(group, index) in data.answer_groups"
                       :key="index"
                  >
                    <div class="text-center white--text">
                      {{ group.title }}
                    </div>
                    <div style="border: 2px dotted white; border-radius: 5px; width: 150px;"
                         class="mb-1 overflow-y-hidden"
                    >
                      <draggable group="answers"
                                 v-model="group.selected"
                                 :style="{ height: `${index === 0 ? 186 : index === 1 ? 124 : 62 }px` }"
                                 @input="setList($event, group.entries_count)"
                      >
                        <div v-for="(item, index) in group.selected"
                             :key="index"
                             class="ma-1"
                        >
                          <v-card class="black--text pa-2 handle"
                                  style="font-size: 14px; cursor: pointer; user-select: none;"
                                  :width="150"
                                  :height="58"
                          >
                            <v-row no-gutters justify="center" align="center" class="fill-height">
                              <v-col cols="auto">
                                <div class="text-center">{{ item }}</div>
                              </v-col>
                            </v-row>
                          </v-card>
                        </div>
                      </draggable>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" top right :timeout="2000">
      <div class="warning--text text-center">
        <v-icon color="warning">mdi-alert-outline</v-icon>
        Only {{ currentGroupCount }}
        item{{ currentGroupCount > 1 ? 's' : '' }}
        allowed in this group
      </div>
    </v-snackbar>
  </v-container>
</template>

<script>
import TopBar from "@/components/Framework/TopBar";
import data from "@/assets/text/peak_future_leader.json";
import draggable from 'vuedraggable';

export default {
  name: "FutureLeader",
  components: {
    TopBar,
    draggable,
  },
  data: () => ({
    timeText: null,
    data: null,
    selectedItem: null,
    snackbar: false,
    dragFromGroup: null,
    currentGroupCount: 0,
  }),
  methods: {
    initData() {
      this.data = JSON.parse(JSON.stringify(data));
    },
    onStart(group) {
      this.dragFromGroup = group;
    },
    setList(list, count) {
      this.currentGroupCount = count;

      if (list.length > count) {
        this.snackbar = true;
        let item = list[list.length - 1];
        this.$set(this.dragFromGroup, this.dragFromGroup.length, item);
        this.$delete(list, list.length - 1);
      }
    },
    reset() {
      this.data = JSON.parse(JSON.stringify(data));
      this.data.answer_groups.forEach((group) => {
        this.$set(group, 'selected', []);
      });
    },
  },
  mounted() {
    this.initData();
  }
}
</script>

<style scoped>

</style>